/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:58:00
 * @LastEditTime: 2022-08-26 15:15:34
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/ShoppingCartTemplate/List/config.tsx
 */
import React from 'react';
//import css from './css.module.less';
import StatusTag from './StatusTag';

import { replaceI18nVariables } from '@/src/tools/tools';
import { EShoppingCartStatus } from '@/src/types/common/order';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import {
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
} from 'src/pages/Order/config';
import { formatMoney } from 'src/tools/helper';
export {
  ETab,
  breadcrumbData,
  columns,
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
  tabDict,
  tabsConfig,
};

enum ETab {
  all = 'all',
  active = 'active',
  draft = 'draft',
  locked = 'locked',
}

const tabDict = {
  [ETab.all]: [
    EShoppingCartStatus.Active,
    EShoppingCartStatus.Draft,
    EShoppingCartStatus.Locked,
  ],
  [ETab.active]: [EShoppingCartStatus.Active],
  [ETab.draft]: [EShoppingCartStatus.Draft],
  [ETab.locked]: [EShoppingCartStatus.Locked],
};

const tabsConfig = (getI18n) => [
  //定义tabs列表
  {
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_tabsConfig_all_name',
    ),
    key: ETab.all,
  },
  {
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_tabsConfig_active_name',
    ),
    key: ETab.active,
  },
  {
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_tabsConfig_draft_name',
    ),
    key: ETab.draft,
  },
  {
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_tabsConfig_Locked_name',
    ),
    key: ETab.locked,
  },
];

const breadcrumbData = (getI18n: any) => [
  {
    url: '',
    name: getI18n('general.home'),
  },
  {
    url: '',
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_breadcrumbData_Order_name',
    ),
  },
  {
    url: '',
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_breadcrumbData_cart_name',
    ),
  },
];

const columns = (timezoneInGMT, reportingCurrency, currency, { getI18n }) => [
  {
    title: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_cart_title',
    ),
    dataIndex: 'cartNo',
    key: 'cartNo',
    default: true,
    optional: true,
    sorter: true,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    minWidth: 160,
  },
  {
    titleGenerate: () =>
      replaceI18nVariables(
        getI18n(
          'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_modifiedtime_title',
        ),
        timezoneInGMT,
      ),
    textTitle: getI18n(
      'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_modified_title',
    ),
    dataIndex: 'modifiedDate',
    default: true,
    optional: true,
    sorter: true,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    key: 'modifiedDate',
    minWidth: 160,
  },
  {
    title: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_total_title',
    ),
    dataIndex: 'totalPrice',
    key: 'totalPrice',
    default: true,
    optional: true,
    childGenerate: (text, record) => {
      const price = formatMoney(text);
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>
            {currency}&nbsp;
            {price}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 120,
  },
  {
    title: () => (
      <div>
        {getI18n(
          'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_currency_title',
        )}
      </div>
    ),
    textTitle: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_currency_title',
    ),
    dataIndex: 'reportingTotalPrice',
    key: 'totalPrice',
    default: true,
    optional: true,
    sorter: true,
    childGenerate: (text, record) => {
      const price = formatMoney(text);
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>
            {reportingCurrency}&nbsp;{price}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 120,
  },
  {
    title: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_saleschannel_title',
    ),
    dataIndex: 'salesChannelName',
    key: 'salesChanneluuid',
    default: true,
    optional: true,
    sorter: true,
    //position: EnumTablePosition.mid,
    childGenerate: (text, record) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{text}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 120,
  },
  {
    title: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_salesRep_title',
    ),
    dataIndex: 'salesRepresentative',
    key: 'salesRepresentative',
    default: true,
    optional: true,
    sorter: true,
    //position: EnumTablePosition.mid,
    childGenerate: (text, record) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{text}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 120,
  },
  {
    title: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.list_config_columns_status_title',
    ),
    dataIndex: 'status',
    key: 'status',
    default: true,
    optional: false,
    sorter: true,
    //position: EnumTablePosition.mid,
    childGenerate: (text, record) => {
      return <StatusTag status={text} />;
    },
    minWidth: 90,
  },
  //
];
